import './App.css';
import {Index} from './Composants/Index';
import {
    BrowserRouter as Router,
    Routes,
    Route
} from 'react-router-dom';
import {Store} from './Composants/Store';
import {ProductPage} from './Composants/ProductPage';
import {Panier} from './Composants/Panier';
import {Commands} from './Composants/Commands';
import {Login} from './Composants/Login';
import {Inscription} from './Composants/Inscription';
import {Logout} from './Composants/Logout';
import {Favoris} from './Composants/Favoris';
import {Legal} from './Composants/Legal';
import {Politique} from './Composants/Politique';
import {About} from './Composants/About';
import {CollectionPage} from './Composants/CollectionPage';
import {DevenirVendeur} from './Composants/DevenirVendeur';
import {Profil} from './Composants/Profil';
import {MailConfirmation} from './Composants/MailConfirmation';
import {PasswordForget} from './Composants/PasswordForget';
import {PasswordReset} from './Composants/PasswordReset';
import Cookies from 'universal-cookie';
import moment from "moment/moment";
import axios from "axios";
import {NotFound} from './Composants/NotFound';
import {HomeLager} from "./Composants/Lager/HomeLager";
import {CartLager} from "./Composants/Lager/CartLager";
import {ProductLager} from "./Composants/Lager/ProductLager";
import {LoginSignupLager} from "./Composants/Lager/LoginSignupLager";
import {ProductsGrid} from "./Composants/Lager/ProductsGrid";

function App() {
    const getCookie = (sKey) => {
        if (!sKey) {
            return null;
        }
        return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
    }

    const cookies = new Cookies();
    if (cookies.get('user') === undefined && getCookie('user') !== null) {
        cookies.set("user", getCookie('user'), {path: "/", expires: moment().add(1, 'months').toDate()});
    }

    if (!window.sessionStorage.getItem('ads')) {
        axios
            .get(process.env.REACT_APP_API_BASE_URL + "/api/ad_spots", {
                headers: {
                    "x-api-token": process.env.REACT_APP_API_TOKEN,
                },
            })
            .then((c) => {
                window.sessionStorage.setItem("ads", JSON.stringify(c.data))
            })
            .catch((error) => {
                console.log(error);
            });
    }

    return (
        <Router>
            <Routes>
                {/*<Route path='*' element={<NotFound />}></Route>*/}
                <Route exact path='/' element={<Index/>}></Route>
                <Route exact path='/boutique' element={<Store/>}></Route>
                <Route exact path='/boutique/:productSlug' element={<ProductPage/>}></Route>
                <Route exact path='/panier' element={<Panier/>}></Route>
                <Route exact path='/commandes' element={<Commands/>}></Route>
                <Route exact path='/inscription' element={<Inscription/>}></Route>
                <Route exact path='/connexion' element={<Login/>}></Route>
                <Route exact path='/cgv' element={<Legal/>}></Route>
                <Route exact path='/confidentialite' element={<Politique/>}></Route>
                <Route exact path='/a-propos' element={<About/>}></Route>
                <Route exact path='/deconnexion' element={<Logout/>}></Route>
                <Route exact path='/favoris' element={<Favoris/>}></Route>
                <Route exact path='/collections/:slug' element={<CollectionPage/>}></Route>
                <Route exact path='/devenir-vendeur' element={<DevenirVendeur/>}></Route>
                <Route exact path='/profil' element={<Profil/>}></Route>
                <Route exact path='/MailConfirmation' element={<MailConfirmation/>}></Route>
                <Route exact path='/PasswordReset' element={<PasswordReset/>}></Route>
                <Route exact path='/mot-de-passe-oublie' element={<PasswordForget/>}></Route>
                {/*  LAGER */}
              <Route exact path='/lager/home' element={<HomeLager/>}></Route>
              <Route exact path='/lager/cart' element={<CartLager/>}></Route>
              <Route exact path='/lager/product' element={<ProductLager/>}></Route>
              <Route exact path='/lager/login-signup' element={<LoginSignupLager/>}></Route>
              <Route exact path='/lager/products-grid' element={<ProductsGrid/>}></Route>

            </Routes>
        </Router>
    );
}


export default App;
